import React, { useEffect, useState } from "react";
import { loadMasterData } from "../utils/loadMasterData";
import localStages from "../data/projectStages.json";
import localFunding from "../data/fundingStages.json";
import localTech from "../data/technologies.json";
import localIndustry from "../data/industryStages.json";

export default function ProjectFilters({
  searchTerm,
  setSearchTerm,
  stageFilter,
  setStageFilter,
  fundingFilter,
  setFundingFilter,
  techFilter,
  setTechFilter,
  industryFilter,
  setIndustryFilter,
  stageCounts,
  fundingCounts,
  techCounts,
  industryCounts,
}) {
  const [stages, setStages] = useState([]);
  const [fundings, setFundings] = useState([]);
  const [technologies, setTechnologies] = useState([]);
  const [industries, setIndustries] = useState([]);

  useEffect(() => {
    async function loadAll() {
      const [stg, fnd, tech, ind] = await Promise.all([
        loadMasterData("projectStages.json", localStages),
        loadMasterData("fundingStages.json", localFunding),
        loadMasterData("technologies.json", localTech),
        loadMasterData("industryStages.json", localIndustry),
      ]);
      setStages(stg);
      setFundings(fnd);
      setTechnologies(tech);
      setIndustries(ind);
    }
    loadAll();
  }, []);

  const formatLabel = (label, count) => `${label} (${count || 0})`;

  // 🔹 Small clear button style
  const ClearButton = ({ onClick }) => (
    <button
      type="button"
      onClick={onClick}
      title="Clear filter"
      style={{
        marginLeft: 4,
        background: "#ccc",
        border: "none",
        borderRadius: "50%",
        width: 22,
        height: 22,
        cursor: "pointer",
        lineHeight: "20px",
        fontSize: 14,
        color: "#333",
      }}
    >
      ×
    </button>
  );

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "10px",
        marginTop: "16px",
        marginBottom: "16px",
        alignItems: "center",
      }}
    >

    {/* Industry */}
      <div style={{ display: "block", alignItems: "center" }}>

      <div className="w3-row w3-small w3-text-grey">  
        Industry
      </div>

      <div className="w3-row">        
        <select
          value={industryFilter}
          onChange={(e) => setIndustryFilter(e.target.value)}
          style={{ padding: "8px", minWidth: 180 }}
        >
          <option value="">
            {formatLabel("All", Object.values(industryCounts || {}).reduce((a, b) => a + b, 0))}
          </option>
          {industries.map((i) => (
            <option key={i} value={i}>
              {formatLabel(i, industryCounts?.[i] || 0)}
            </option>
          ))}
        </select>
        {industryFilter && <ClearButton onClick={() => setIndustryFilter("")} />}
      </div>
      </div>

      {/* Technology */}
        <div style={{ display: "block", alignItems: "center" }}>

      <div className="w3-row w3-small w3-text-grey">  
        Technology
      </div>
      
      <div className="w3-row">   
        <select
          value={techFilter}
          onChange={(e) => setTechFilter(e.target.value)}
          style={{ padding: "8px", minWidth: 180 }}
        >
          <option value="">
            {formatLabel("All", Object.values(techCounts).reduce((a, b) => a + b, 0))}
          </option>
          {technologies.map((t) => (
            <option key={t} value={t}>
              {formatLabel(t, techCounts[t] || 0)}
            </option>
          ))}
        </select>
        {techFilter && <ClearButton onClick={() => setTechFilter("")} />}
      </div>
      </div>

      {/* Technology */}
        <div style={{ display: "block", alignItems: "center" }}>

      <div className="w3-row w3-small w3-text-grey">  
        Project Stage
      </div>
      
      <div className="w3-row">
      
        <select
          value={stageFilter}
          onChange={(e) => setStageFilter(e.target.value)}
          style={{ padding: "8px", minWidth: 180 }}
        >
          <option value="">
            {formatLabel("All", Object.values(stageCounts).reduce((a, b) => a + b, 0))}
          </option>
          {stages.map((s) => (
            <option key={s} value={s}>
              {formatLabel(s, stageCounts[s] || 0)}
            </option>
          ))}
        </select>
        {stageFilter && <ClearButton onClick={() => setStageFilter("")} />}
       </div>
      </div>

      {/* Funding */}
        <div style={{ display: "block", alignItems: "center" }}>

      <div className="w3-row w3-small w3-text-grey">  
        Funding
      </div>
      
      <div className="w3-row">
        <select
          value={fundingFilter}
          onChange={(e) => setFundingFilter(e.target.value)}
          style={{ padding: "8px", minWidth: 180 }}
        >
          <option value="">
            {formatLabel("All", Object.values(fundingCounts).reduce((a, b) => a + b, 0))}
          </option>
          {fundings.map((f) => (
            <option key={f} value={f}>
              {formatLabel(f, fundingCounts[f] || 0)}
            </option>
          ))}
        </select>
        {fundingFilter && <ClearButton onClick={() => setFundingFilter("")} />}
      </div>
      </div>

    </div>
  );
}
